import CNEnum from "@src/Locales/Constants/CNEnum";
import { CommonEnum } from "@src/Locales/Constants/CommonEnum";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as Kiosk } from "./svgs/kiosk.svg";
import { ReactComponent as POS } from "./svgs/pos.svg";
import { ReactComponent as KDS } from "./svgs/kds.svg";
import { ReactComponent as HandleOrder } from "./svgs/handleOrder.svg";
import { ReactComponent as ElectronicMenu } from "./svgs/electronicMenu.svg";
import { ReactComponent as IntelligentCall } from "./svgs/intelligentCall.svg";
import { ReactComponent as H5AndApplet } from "./svgs/h5AndApplet.svg";
import { ReactComponent as AggregateTakeout } from "./svgs/aggregateTakeout.svg";
import { ReactComponent as OnLinePayment } from "./svgs/onLinePayment.svg";
import { ReactComponent as ElectronicInvoice } from "./svgs/electronicInvoice.svg";
import { ReactComponent as TaxAdmin } from "./svgs/taxAdmin.svg";
import { ReactComponent as Predetermine } from "./svgs/predetermine.svg";
import { ReactComponent as IntelligentQueue } from "./svgs/intelligentQueue.svg";
import { ReactComponent as EvaluateInteraction } from "./svgs/evaluateInteraction.svg";
import { ReactComponent as BusinessPlatformTicket } from "./svgs/businessPlatformTicket.svg";
import { ReactComponent as MarketingActivities } from "./svgs/marketingActivities.svg";
import { ReactComponent as MemberManage } from "./svgs/memberManage.svg";
import { ReactComponent as IntelligentStored } from "./svgs/intelligentStored.svg";
import { ReactComponent as GroupBuying } from "./svgs/groupBuying.svg";
import { ReactComponent as Ticket } from "./svgs/ticket.svg";
import { ReactComponent as MemberAnalysis } from "./svgs/memberAnalysis.svg";
import { ReactComponent as Inventory } from "./svgs/inventory.svg";
import { ReactComponent as Procure } from "./svgs/procure.svg";
import { ReactComponent as Cost } from "./svgs/cost.svg";
import { ReactComponent as Delivery } from "./svgs/delivery.svg";
import { ReactComponent as NumberSpeak } from "./svgs/numberSpeak.svg";
import { ReactComponent as MerchantManagePlatform } from "./svgs/merchantManagePlatform.svg";
import { ReactComponent as EfficientSupportTools } from "./svgs/efficientSupportTools.svg";
import { ReactComponent as International } from "./svgs/international.svg";
import { ReactComponent as MasterDataManage } from "./svgs/masterDataManage.svg";
import { ReactComponent as IntegrationCenter } from "./svgs/integrationCenter.svg";
import { ReactComponent as MultiOrganizeControl } from "./svgs/multiOrganizeControl.svg";
import { ReactComponent as ChainCoordination } from "./svgs/chainCoordination.svg";
import { ReactComponent as FlexibleOperation } from "./svgs/flexibleOperation.svg";
import { ReactComponent as EfficientManage } from "./svgs/efficientManage.svg";
import { ReactComponent as HelpManual } from "./svgs/helpManual.svg";
import { ReactComponent as ReleaseAnnouncement } from "./svgs/releaseAnnouncement.svg";
import { ReactComponent as VideoTutorials } from "./svgs/videoTutorials.svg";
import { ReactComponent as Develop } from "./svgs/develop.svg";
import { ReactComponent as TeaDrink } from "./svgs/teaDrink.svg";
import { ReactComponent as FastFood } from "./svgs/fastFood.svg";
import { ReactComponent as Dinner } from "./svgs/dinner.svg";
import { ReactComponent as FrequentlyAskedQuestions } from "./svgs/frequentlyAskedQuestions.svg";

const useNavList = () => {
  const { t, i18n } = useTranslation();
  const navList = useMemo(() => {
    return [
      // {
      //   title: t(CNEnum.home),
      //   key: "home",
      //   path: "/home",
      // },
      {
        title: t(CNEnum.product),
        key: "product",
        path: "/product",
        chevron: "down",
        showFlexGroupStrokeWidth: true,
        content: [
          {
            title: t(CNEnum.efficientOperation),
            path: "/product/efficient", // 页面路径
            list: [
              {
                label: `KIOSK（${t(CommonEnum.largeScreenOrder)}）`,
                anchor: "kiosk",
                key: "kiosk",
                icon: <Kiosk />,
              },
              {
                label: `POS（ ${t(CNEnum.cashierSystem)}）`,
                anchor: "pos",
                key: "pos",
                icon: <POS />,
              },
              {
                label: `KDS（${t(CNEnum.kitchenProduceSystem)}）`,
                anchor: "kds",
                key: "kds",
                icon: <KDS />,
              },
              {
                label: t(CNEnum.handheldOrder),
                anchor: "handleOrder",
                key: "handleOrder",
                icon: <HandleOrder />,
              },
              {
                label: t(CNEnum.electronicMenu),
                anchor: "electronicMenu",
                key: "electronicMenu",
                icon: <ElectronicMenu />,
              },
              {
                label: t(CNEnum.intelligentCalling),
                anchor: "intelligentCall",
                key: "intelligentCall",
                icon: <IntelligentCall />,
              },
            ],
          },
          {
            title: t(CNEnum.onlineSmartRestaurant),
            path: "/product/online-restaurant", // 页面路径
            list: [
              {
                label: t(CNEnum.h5AndApplet),
                anchor: "onlineSystem",
                key: "onlineSystem",
                icon: <H5AndApplet />,
              },
              {
                label: t(CNEnum.aggregateTakeout),
                anchor: "takeaway",
                key: "takeaway",
                icon: <AggregateTakeout />,
              },
              {
                label: t(CNEnum.onLinePayment),
                anchor: "onlinePayment",
                key: "onlinePayment",
                icon: <OnLinePayment />,
              },
              {
                label: t(CNEnum.electronicInvoice),
                anchor: "invoiceTax",
                type: "invoice",
                key: "invoiceTaxinvoice",
                icon: <ElectronicInvoice />,
              },
              {
                label: t(CNEnum.taxAdmin),
                anchor: "invoiceTax",
                type: "tax",
                key: "invoiceTaxtax",
                icon: <TaxAdmin />,
              },
              {
                label: t(CNEnum.predetermine),
                anchor: "preBook",
                key: "preBook",
                icon: <Predetermine />,
              },
              {
                label: t(CNEnum.intelligentQueue),
                anchor: "lineUp",
                key: "lineUp",
                icon: <IntelligentQueue />,
              },
              {
                label: t(CNEnum.evaluateInteraction),
                anchor: "evaluate",
                key: "evaluate",
                icon: <EvaluateInteraction />,
              },
              {
                label: t(CNEnum.businessPlatformTicket),
                anchor: "businessTicket",
                key: "businessTicket",
                icon: <BusinessPlatformTicket />,
              },
            ],
          },
          {
            title: t(CNEnum.smartMarketing),
            path: "/product/marketing", // 页面路径
            list: [
              {
                label: t(CNEnum.marketingActivities),
                anchor: "activities",
                key: "activities",
                icon: <MarketingActivities />,
              },
              {
                label: t(CNEnum.memberManage),
                anchor: "memberManage",
                key: "memberManage",
                icon: <MemberManage />,
              },
              {
                label: t(CNEnum.intelligentStoredValue),
                anchor: "intelligentStored",
                key: "intelligentStored",
                icon: <IntelligentStored />,
              },
              {
                label: t(CNEnum.groupBuying),
                anchor: "gruopBuy",
                key: "gruopBuy",
                icon: <GroupBuying />,
              },
              { label: t(CNEnum.ticket), anchor: "ticket", key: "ticket", icon: <Ticket /> },
              {
                label: t(CNEnum.memberAnalysis),
                anchor: "memberAnalysis",
                key: "memberAnalysis",
                icon: <MemberAnalysis />,
              },
            ],
          },
          {
            title: t(CNEnum.supplyChain),
            path: "/product/supply-chain", // 页面路径
            list: [
              {
                label: t(CNEnum.inventory),
                anchor: "storeInventory",
                key: "storeInventory",
                icon: <Inventory />,
              },
              { label: t(CNEnum.procure), anchor: "procure", key: "procure", icon: <Procure /> },
              {
                label: t(CNEnum.cost),
                anchor: "costControl",
                key: "costControl",
                icon: <Cost />,
              },
              {
                label: t(CNEnum.delivery),
                anchor: "delivery",
                key: "delivery",
                icon: <Delivery />,
              },
            ],
          },
          {
            title: t(CNEnum.manageAndDecision),
            path: "/product/manage-decision", // 页面路径
            list: [
              {
                label: t(CommonEnum.numberSpeak),
                anchor: "numberSpeak",
                key: "numberSpeak",
                icon: <NumberSpeak />,
              },
              {
                label: t(CNEnum.merchantManagePlatform),
                anchor: "manageBackend",
                key: "manageBackend",
                icon: <MerchantManagePlatform />,
              },
              {
                label: t(CNEnum.efficientSupportTools),
                anchor: "supportTools",
                key: "supportTools",
                icon: <EfficientSupportTools />,
              },
              {
                label: t(CNEnum.international),
                anchor: "international",
                key: "international",
                icon: <International />,
              },
              {
                label: t(CNEnum.masterDataManage),
                anchor: "numberSpeak",
                key: "",
                icon: <MasterDataManage />,
              },
              {
                label: t(CNEnum.integrationCenter),
                anchor: "integratedCenter",
                key: "integratedCenter",
                icon: <IntegrationCenter />,
              },
            ],
          },
          {
            title: t(CNEnum.chainControl),
            path: "/product/chain-control", // 页面路径
            list: [
              {
                label: t(CNEnum.multiOrganizeControl),
                anchor: "efficientLinkage",
                key: "efficientLinkage",
                icon: <MultiOrganizeControl />,
              },
              {
                label: t(CNEnum.chainCoordination),
                anchor: "chainCoordination",
                key: "chainCoordination",
                icon: <ChainCoordination />,
              },
              {
                label: t(CNEnum.flexibleOperation),
                anchor: "quickExpansion",
                key: "quickExpansion",
                icon: <FlexibleOperation />,
              },
              {
                label: t(CNEnum.efficientManage),
                anchor: "efficientManage",
                key: "efficientManage",
                icon: <EfficientManage />,
              },
            ],
          },
        ],
      },
      {
        title: t(CNEnum.resolvaPlans),
        key: "industry",
        path: "/industry",
        chevron: "down",
        noNextLevel: true,
        showFlexGroupStrokeWidth: false,
        mobileContent: [
          {
            title: t(CNEnum.fastFood),
            path: "/industry/fast-food", // 页面路径
          },
          {
            title: t(CNEnum.dinner),
            path: "/industry/dinner", // 页面路径
          },
          {
            title: t(CNEnum.teaDrink),
            path: "/industry/tea-drinks", // 页面路径
          },
        ],
        content: [
          {
            title: `${t(CNEnum.industry)}${t(CNEnum.resolvaPlans)}`,
            list: [
              {
                label: t(CNEnum.fastFood),
                path: "/industry/fast-food", // 页面路径
                icon: <FastFood />,
              },
              {
                label: t(CNEnum.dinner),
                path: "/industry/dinner", // 页面路径
                icon: <Dinner />,
              },
              {
                label: t(CNEnum.teaDrink),
                path: "/industry/tea-drinks", // 页面路径
                icon: <TeaDrink />,
              },
            ],
          },
        ],
      },
      {
        title: t(CNEnum.customer),
        key: "cases",
        path: "/cases",
      },
      // {
      //   title: t(CNEnum.study),
      //   key: "study",
      //   path: "/study",
      // },
      // {
      //   title: t(CNEnum.cooperativePartner),
      //   key: "partner",
      //   path: "/partner",
      // },
      {
        title: t(CNEnum.infoCenter),
        key: "article-center",
        path: "/article-center",
      },
      {
        title: t(CNEnum.companyIntroduction),
        key: "company-introduce",
        path: "/company-introduce",
      },
      {
        title: t(CNEnum.downloadCenter),
        key: "download-center",
        path: "/download-center",
      },
      {
        title: t(CNEnum.resource),
        key: "resource",
        path: "/resource",
        chevron: "down",
        noNextLevel: true, // 废弃
        mobileHide: true,
        showFlexGroupStrokeWidth: false,
        mobileContent: [
          {
            title: t(CNEnum.helpManual),
            path: "/resource/helpManual",
            link: "https://help.restosuite.cn/zh/helps",
            icon: <HelpManual />,
          },
          {
            title: t(CNEnum.releaseAnnouncement),
            path: "/resource/releaseAnnouncement",
            link: "https://help.restosuite.cn/zh/release-notes/rn-250407",
            icon: <ReleaseAnnouncement />,
          },
          {
            title: t(CNEnum.videoTutorials),
            path: "/resource/videoTutorials",
            link: "https://help.restosuite.cn/zh/videos",
            icon: <VideoTutorials />,
          },
          {
            title: t(CNEnum.frequentlyAskedQuestions),
            path: "/resource/frequentlyAskedQuestions",
            link: "https://help.restosuite.cn/zh/faq/scm/link-store-distribution",
          },
          {
            title: t(CNEnum.developerPlatform),
            path: "develop",
            icon: <Develop />,
          },
        ],
        content: [
          {
            title: t(CNEnum.resource),
            list: [
              {
                label: t(CNEnum.helpManual),
                path: "/resource/helpManual",
                link: "https://help.restosuite.cn/zh/helps",
                icon: <HelpManual />,
              },
              {
                label: t(CNEnum.releaseAnnouncement),
                path: "/resource/releaseAnnouncement",
                link: "https://help.restosuite.cn/zh/release-notes/rn-250407",
                icon: <ReleaseAnnouncement />,
              },
              {
                label: t(CNEnum.videoTutorials),
                path: "/resource/videoTutorials",
                link: "https://help.restosuite.cn/zh/videos",
                icon: <VideoTutorials />,
              },
              {
                label: t(CNEnum.frequentlyAskedQuestions),
                path: "/resource/frequentlyAskedQuestions",
                link: "https://help.restosuite.cn/zh/faq/scm/link-store-distribution",
                icon: <FrequentlyAskedQuestions />,
              },
              {
                label: t(CNEnum.developerPlatform),
                path: "develop",
                icon: <Develop />,
              },
            ],
          },
        ],
      },
    ];
  }, [i18n.language]);

  return {
    navList,
  };
};

export default useNavList;
